import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/yardService";
import { getAll } from "../../services/visaService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import queryString from "query-string";

class YardEditForm extends Form {
  state = {
    expiryDate: new Date(),
    data: {
      visa_id: "",
      name: "",
      mobile: "",
      rent: "",
      emirates_id: "",
    },
    visas: [],
    errors: {},
  };

  schema = {
    visa_id: Joi.number().allow("").label("Visa Account"),
    name: Joi.string().allow("").label("Name"),
    mobile: Joi.string().allow("").label("Mobile"),
    rent: Joi.number().required().label("Rent"),
    emirates_id: Joi.allow("").label("Emirates Id"),
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });

      const dateData = this.mapingData(account);

      this.setState({
        expiryDate:
          dateData.expiryDate != "" ? new Date(dateData.expiryDate) : "",
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    this.setState({ blocking: true });

    await this.populateAccount();
    const { data: visasAccounts } = await getAll();
    const visas = [{ id: "", name: "Select" }, ...visasAccounts];

    this.setState({ visas, blocking: false });
  }

  mapingData(account) {
    return {
      expiryDate: account.expiry_date,
    };
  }

  mapToViewModel(account) {
    return {
      visa_id: account.visa != null ? account.visa.id : "",
      name: account.name ? account.name : "",
      mobile: account.mobile ? account.mobile : "",
      rent: account.rent,
      emirates_id: account.emirates_id,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      this.setState({ blocking: true });

      let event = new Date(this.state.expiryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      //formData.append("expiry_date", date);
      // formData.append("_method", "PUT");

      data.expiry_date = date;

      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Account has been updated successfully.");
      this.props.history.push("/yards-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.visa_id)
          errors.visa_id = ex.response.data.errors.visa_id;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.rent)
          errors.rent = ex.response.data.errors.rent;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/yard.png";
    const { keyword, status } = queryString.parse(this.props.location.search);

    // if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update yard account</h1>
        <Link
          to={`/yards-accounts?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary"
          style={{ marginBottom: "1rem", display: "inline-block" }}
        >
          Back
        </Link>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update yard account</h3>
              <p>Provide the information below to update the account.</p>
              {this.renderSelect(
                "visa_id",
                "Select visa account (optional)",
                this.state.visas
              )}

              {this.renderInput("name", "Name", "text")}
              {this.renderInput("mobile", "Mobile", "text")}
              {this.renderInput("rent", "Rent", "text")}
              <label>Renewal Date</label>

              <DatePicker
                selected={this.state.expiryDate}
                onChange={this.handleChangeExpiry}
                className="input"
              />
              {this.renderInput("emirates_id", "Emirates Id", "text")}
              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default YardEditForm;
